import { updateLocationQuery } from "../../router/actions";
import {
  clearSelections,
  setNewSearch,
  setNextPriceRangeToCurrent
} from "../actions";
import getQueryIfNewSearch from "./getQueryIfNewSearch";

/*
TODO avoid circular depencies, move this actions to their own file:
  clearSelections,
  setNewSearch,
  setNextPriceRangeToCurrent
*/

export default function applyFacets() {
  return (dispatch, getState) => {
    const { shouldUpdate, next } = getQueryIfNewSearch(getState());

    if (shouldUpdate) {
      dispatch(setNewSearch());
      dispatch(
        updateLocationQuery({
          query: next.query
        })
      );
      dispatch(setNextPriceRangeToCurrent(next.priceRange));
    }

    dispatch(clearSelections());
  };
}
